export const GENERIC_ERROR_KEY = 'generic'

export const FOB_NUMBER_ALREADY_IN_USE = 'fobNumberAlreadyInUse'
export const FOB_CREDENTIAL_STAFF_ONLY = 'fobCredentialStaffOnly'

export const CLIENT_LOGIN_NOT_FOUND = 'clientLoginNotFound'

// MEM-301 enrollment errors. The site config is a prerequisite for deriving a fob,
// and a random UID has no stable serial to derive from.
export const FOB_DERIVATION_NOT_CONFIGURED = 'fobDerivationNotConfigured'
export const FOB_CSN_INVALID = 'fobCsnInvalid'
export const FOB_CSN_RANDOM_UID = 'fobCsnRandomUid'
export const FOB_DERIVATION_TOO_LARGE = 'fobDerivationTooLarge'

export const DEVICE_NOT_FOUND = 'deviceNotFound'
export const DEVICE_NOT_IN_FOB_MODE = 'deviceNotInFobMode'
export const FOB_CAPTURE_NOT_PENDING = 'fobCaptureNotPending'
export const FOB_CAPTURE_NOT_FOUND = 'fobCaptureNotFound'

export const ERROR_CODES = {
  TAX_NOT_ENABLED: 'TAX_NOT_ENABLED',
  ACCESS_RULE_ASSIGNABILITY_NOT_ENABLED: 'ACCESS_RULE_ASSIGNABILITY_NOT_ENABLED',
  CONTENT_LIBRARY_FEATURE_DISABLED: 'CONTENT_LIBRARY_FEATURE_DISABLED',
  STREAKS_FEATURE_DISABLED: 'STREAKS_FEATURE_DISABLED',
  CONTENT_LIBRARY_ALL_LOCATIONS_ON: 'CONTENT_LIBRARY_ALL_LOCATIONS_ON',
  CONTENT_LIBRARY_REQUIRES_EXPERIENCE: 'CONTENT_LIBRARY_REQUIRES_EXPERIENCE',
  EXPERIENCE_REQUIRED_BY_CONTENT_LIBRARY: 'EXPERIENCE_REQUIRED_BY_CONTENT_LIBRARY',
  MEMBERSHIP_PLAN_CHANGE_BY_CATEGORY_NOT_ENABLED: 'MEMBERSHIP_PLAN_CHANGE_BY_CATEGORY_NOT_ENABLED',
  FAMILY_SHAREABLE_TEMPLATE_TYPE_NOT_ALLOWED: 'FAMILY_SHAREABLE_TEMPLATE_TYPE_NOT_ALLOWED',
  FAMILY_SHAREABLE_LOCKED: 'FAMILY_SHAREABLE_LOCKED',
  FAMILY_SHAREABLE_GUEST_PASS_CONFLICT: 'FAMILY_SHAREABLE_GUEST_PASS_CONFLICT',
  PARTNER_BOOKINGS_DASHBOARD_DISABLED: 'PARTNER_BOOKINGS_DASHBOARD_DISABLED',
  ONE_ACTIVE_PER_FAMILY_TEMPLATE_TYPE_NOT_ALLOWED:
    'ONE_ACTIVE_PER_FAMILY_TEMPLATE_TYPE_NOT_ALLOWED',
  STAFF_EMAIL_RECIPIENT_UNDELIVERABLE: 'STAFF_EMAIL_RECIPIENT_UNDELIVERABLE',
  ALREADY_CHECKED_IN: 'ALREADY_CHECKED_IN',
} as const

export const MEMBERSHIP_DISCOUNT_ALL_PAYMENTS_UNAVAILABLE =
  'membershipDiscountAllPaymentsUnavailable'
